import { useData } from '../context/DataContext';
import './Legal.css';

export default function Privacy() {
  const { data, loading } = useData();
  if (loading || !data) return <div className="page">Loading...</div>;
  const { company } = data;

  return (
    <main className="page legal-page">
      <div className="container">
        <div className="section-title">
          <span className="section-title__label">Legal</span>
          <h1 className="section-title__heading">Privacy Policy</h1>
          <p className="section-title__description">Last updated: April 2026</p>
        </div>

        <div className="legal-page__content">
          <section className="legal-page__section">
            <h2>1. Information We Collect</h2>
            <p>At {company.fullName}, we collect information you provide directly, such as your name, email address, and any messages you send through our contact forms. We also automatically collect certain technical data including browser type, device information, and usage patterns.</p>
          </section>

          <section className="legal-page__section">
            <h2>2. How We Use Your Information</h2>
            <p>We use collected information to provide and improve our services, communicate with you about our products, send updates and newsletters (with your consent), and ensure the security of our platforms.</p>
          </section>

          <section className="legal-page__section">
            <h2>3. Data Protection</h2>
            <p>We implement industry-standard security measures to protect your personal data. All data transmissions are encrypted using SSL/TLS protocols. We regularly review and update our security practices.</p>
          </section>

          <section className="legal-page__section">
            <h2>4. Third-Party Services</h2>
            <p>Our platforms may integrate with third-party services (analytics, payment processors, cloud providers). These services have their own privacy policies, and we encourage you to review them.</p>
          </section>

          <section className="legal-page__section">
            <h2>5. Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal data. You may opt out of marketing communications at any time. For data-related requests, contact us at {company.email}.</p>
          </section>

          <section className="legal-page__section">
            <h2>6. Contact</h2>
            <p>For privacy-related inquiries, reach out to us at <strong>{company.email}</strong> or write to us at {company.address}.</p>
          </section>
        </div>
      </div>
    </main>
  );
}
